import * as React from 'react';

import {Button} from 'shells/button/button';

import type {MeetingFragment as Meeting} from 'nutshell-graphql-types';

import {appHistory} from '../../../history';
import {addNotification} from '../../../notifications/index';

import {useGetAssignments} from '../assignment/graphql/hooks/use-get-assignments';
import {useUpdateManagedMeetingTemplateAssignments} from '../assignment/graphql/hooks/use-update-managed-meeting-template-assignments';
import {UsersTeamsSelectionModal} from '../assignment/users-teams-selection-modal';

type Props = {
    meeting: Meeting;
    activeTab: string;
};

export function AssignManagedMeetingButton(props: Props) {
    const [isOpen, setIsOpen] = React.useState(false);

    const {userAssignments, teamAssignments} = useGetAssignments(props.meeting.id);
    const {updateManagedMeetingTemplateAssignments} = useUpdateManagedMeetingTemplateAssignments();

    const allSelectedAssignments = [...userAssignments, ...teamAssignments];
    const selectedUsersAndTeams = allSelectedAssignments.map(
        (assignment) => assignment.node.assigneeEntity
    );

    return (
        <>
            <Button variant='primary' size='big' onClick={() => setIsOpen(true)}>
                Assign this meeting
            </Button>
            {isOpen && (
                <UsersTeamsSelectionModal
                    isOpen={isOpen}
                    // @ts-expect-error
                    selected={selectedUsersAndTeams}
                    type='users-teams'
                    onSelection={({selectedUsers, selectedTeams}) => {
                        setIsOpen(false);
                        updateManagedMeetingTemplateAssignments({
                            meetingId: props.meeting.id,
                            users: selectedUsers,
                            teams: selectedTeams,
                        })
                            .then(() => {
                                if (props.activeTab !== 'assignment') {
                                    appHistory.push(`${props.meeting.htmlUrlPath}/assignment`);
                                }
                            })
                            .catch(() => {
                                addNotification('Assignment update failed', {
                                    body: 'An unexpected error occurred. Please try again later.',
                                    icon: 'frowny',
                                });
                            });
                    }}
                    onClose={() => setIsOpen(false)}
                />
            )}
        </>
    );
}
